import PropTypes from 'prop-types';

import styles from './Banner.module.css';
import CountDown from './CountDown/CountDown';

const SingleBanner = ({ data, url, external_url, image_url, onClick }) => {
  if (external_url) {
    return (
      <div className={styles.BannerContainer}>
        <a className={styles.BannerLink} href={url} rel="noreferrer" target="_blank">
          <img alt="banner" className={styles.SingleImage} src={image_url} />
        </a>
      </div>
    );
  }

  return (
    <div className={styles.BannerContainer} onClick={onClick}>
      <div className={styles.SingleBannerContainer}>
        <img alt="banner" className={styles.SingleImage} src={image_url} />
        <CountDown
          code={data.design1.code}
          color={data.design1.color}
          ended_at={data.ended_at1}
          is_active={data.counter_is_active1}
          now={data.now}
          position={data.design1.position}
          started_at={data.started_at1}
        />
      </div>
    </div>
  );
};

SingleBanner.propTypes = {
  data: PropTypes.object,
  url: PropTypes.string,
  external_url: PropTypes.bool,
  image_url: PropTypes.string,
  onClick: PropTypes.func
};

export default SingleBanner;
